export const EMAIL_FIELD_FULL_NAME = 'full_name';
export const EMAIL_FIELD_EMAIL = 'email';
export const EMAIL_FIELD_PHONE = 'phone_number';
export const EMAIL_FIELD_PASSWORD = 'password';
export const EMAIL_FIELD_PASSWORD_CONFIRM = 'password_confirm';
